import {useEffect,type RefObject} from "react";
import "./MenuLayer.css";

/** Keep dropdowns in the browser top layer, outside card clipping and stacking contexts. */
export function useMenuLayer(trigger:RefObject<HTMLElement|null>) {
 useEffect(()=>{
  const anchor=trigger.current,menu=anchor?.closest("details"),panel=menu?.querySelector<HTMLElement>(":scope > div");
  if(!anchor||!menu||!panel)return;
  menu.dataset.menuLayer="true";panel.classList.add("mundely-menu-layer");
  const native=typeof panel.showPopover==="function";
  if(native)panel.setAttribute("popover","manual");
  let frame=0;
  const style=(key:string,value:string)=>panel.style.setProperty(key,value,"important");
  const position=()=>{
   if(!menu.open)return;
   const box=anchor.getBoundingClientRect(),viewport=window.visualViewport;
   const left=viewport?.offsetLeft||0,top=viewport?.offsetTop||0,width=viewport?.width||innerWidth,height=viewport?.height||innerHeight;
   if(box.bottom<top||box.top>top+height){menu.open=false;return;}
   style("position","fixed");style("margin","0");style("right","auto");style("bottom","auto");style("max-width",`${width-16}px`);
   const below=top+height-box.bottom-14,above=box.top-top-14;
   const wanted=panel.scrollHeight,up=below<wanted&&above>below;
   style("max-height",`${Math.max(60,up?above:below)}px`);style("overflow-y","auto");
   const size=panel.getBoundingClientRect();
   style("left",`${Math.max(left+8,Math.min(box.right-size.width,left+width-size.width-8))}px`);
   style("top",`${Math.max(top+8,up?box.top-size.height-6:box.bottom+6)}px`);
  };
  const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(position);};
  const toggle=()=>{
   anchor.setAttribute("aria-expanded",String(menu.open));
   if(menu.open){
    document.querySelectorAll<HTMLDetailsElement>('details[data-menu-layer="true"][open]').forEach(other=>{if(other!==menu&&!other.contains(menu))other.open=false;});
    if(native&&!panel.matches(":popover-open"))panel.showPopover();
    position();schedule();
   }else if(native&&panel.matches(":popover-open"))panel.hidePopover();
  };
  const outside=(event:PointerEvent)=>{if(menu.open&&!menu.contains(event.target as Node))menu.open=false;};
  const escape=(event:KeyboardEvent)=>{if(menu.open&&event.key==="Escape"){event.preventDefault();event.stopImmediatePropagation();menu.open=false;anchor.focus();}};
  menu.addEventListener("toggle",toggle);document.addEventListener("pointerdown",outside);document.addEventListener("keydown",escape,true);
  window.addEventListener("resize",schedule);document.addEventListener("scroll",schedule,true);window.visualViewport?.addEventListener("resize",schedule);
  const observer=new ResizeObserver(schedule);observer.observe(panel);toggle();
  return()=>{cancelAnimationFrame(frame);observer.disconnect();menu.removeEventListener("toggle",toggle);document.removeEventListener("pointerdown",outside);document.removeEventListener("keydown",escape,true);window.removeEventListener("resize",schedule);document.removeEventListener("scroll",schedule,true);window.visualViewport?.removeEventListener("resize",schedule);if(native&&panel.matches(":popover-open"))panel.hidePopover();};
 },[trigger]);
}
